/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContactWithRelations } from '../../models/contact-with-relations';

export interface EditorGetContact$Params {
  id: string;
}

export function editorGetContact(http: HttpClient, rootUrl: string, params: EditorGetContact$Params, context?: HttpContext): Observable<StrictHttpResponse<ContactWithRelations>> {
  const rb = new RequestBuilder(rootUrl, editorGetContact.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContactWithRelations>;
    })
  );
}

editorGetContact.PATH = '/editor/contact';
